import { Org, OrgPayload } from '../types'

const fromPayload = (payload: OrgPayload) => ({ id: payload.id } as Org)

export default { fromPayload }
